import { experimentStates, experimentFlagsHelper } from '@zola-helpers/client';

const { CONTROL } = experimentStates;

// Experiment Keys
export const VIRTUAL_EVENTS = 'virtual-events';
export const ALL_PLANNING_DASH = 'all-planning-dash';
export const UNIFY_PAPER_ACCOUNT = 'unify-paper-account';
export const ONBOARD_CITY_STATE = 'onboard-city-state';
export const WEB_TO_REGISTRY_HERO = 'web-to-registry-hero';
export const SELECT_PRODUCT_NEW_QS = 'select-product-new-qs';
export const WEDDING_WEBSITE_NEW_QS = 'wedding-website-onboard';
export const WEDDING_CHECKLIST_NEW_QS = 'wedding-checklist-new-qs';
export const ZOOM_UPGRADE = 'zoom-upgrade'; //  CE-614, Added 1/6/2021

const FALLBACK_VARIATIONS = {
  [VIRTUAL_EVENTS]: experimentFlagsHelper.createExperimentFlags(CONTROL, CONTROL, CONTROL),
  [ALL_PLANNING_DASH]: experimentFlagsHelper.createExperimentFlags(),
  [UNIFY_PAPER_ACCOUNT]: experimentFlagsHelper.createExperimentFlags(),
  [ONBOARD_CITY_STATE]: experimentFlagsHelper.createExperimentFlags(),
  [WEB_TO_REGISTRY_HERO]: experimentFlagsHelper.createExperimentFlags(),
  [SELECT_PRODUCT_NEW_QS]: experimentFlagsHelper.createExperimentFlags(),
  [WEDDING_WEBSITE_NEW_QS]: experimentFlagsHelper.createExperimentFlags(),
  [WEDDING_CHECKLIST_NEW_QS]: experimentFlagsHelper.createExperimentFlags(),
  [ZOOM_UPGRADE]: experimentFlagsHelper.createExperimentFlags(),
};

export default experimentFlagsHelper.makeExperimentFlags(FALLBACK_VARIATIONS);



// WEBPACK FOOTER //
// ./src/util/experimentFlags.js